import apiClient from './client'
import API from '@/api/API'
import { NotebookResponse, CreateNotebookRequest, UpdateNotebookRequest } from '@/lib/types/api'

export const notebooksApi = {
  list: async (params?: { archived?: boolean; order_by?: string }) => {
    const response = await apiClient.get<NotebookResponse[]>(API.notebooks.base, { params })
    return response.data
  },

  get: async (id: string) => {
    const response = await apiClient.get<NotebookResponse>(`${API.notebooks.base}/${id}`)
    return response.data
  },

  create: async (data: CreateNotebookRequest) => {
    const response = await apiClient.post<NotebookResponse>(API.notebooks.base, data)
    return response.data
  },

  update: async (id: string, data: UpdateNotebookRequest) => {
    const response = await apiClient.put<NotebookResponse>(`${API.notebooks.base}/${id}`, data)
    return response.data
  },

  delete: async (id: string) => {
    await apiClient.delete(`${API.notebooks.base}/${id}`)
  },

  addSource: async (notebookId: string, sourceId: string) => {
    const response = await apiClient.post(`${API.notebooks.base}/${notebookId}/sources/${sourceId}`)
    return response.data
  },

  removeSource: async (notebookId: string, sourceId: string) => {
    const response = await apiClient.delete(`${API.notebooks.base}/${notebookId}/sources/${sourceId}`)
    return response.data
  }
}
